import React, {ReactElement} from 'react';
import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import {getElementShadow} from '../../incase-domain/common/elementShadow';
import {IElement} from '../../incase-domain/elements';
import {ELEMENT} from '../../incase-domain/elements/base/ElementTypes';
import {isCoverHtmlElement} from '../../incase-domain/elements/html/html';
import BaseElementWrapper from '../../ui/components/common/elementWrapper/BaseElementWrapper';
import ElementContextMenuTrigger from '../../ui/components/contextMenu/ElementContextMenu';
import ElementTyped from './element.typed';

interface ElementComponentProps {
    element: IElement;
    elementIndex: number;
    onOptions?: (id: string, silent?: boolean) => void;
    hasError?: boolean;
}

function ElementComponentMobile(props: ElementComponentProps): ReactElement {
    const {element, elementIndex, hasError, onOptions} = props;

    const {keyIndex} = element;
    const coverSlide = isCoverHtmlElement(element);

    if (element.type === ELEMENT.MODAL) return <></>;

    return (
        <ElementContextMenuTrigger element={element} elementIndex={elementIndex}>
            <div
                id={`mobile-${keyIndex}`}
                style={{
                    ...getElementShadow(element.boxShadow, element.questionBackgroundBorderRadius, element.questionBackgroundColor),
                    ...(coverSlide ? {width: '100%', height: '100%'} : {}),
                }}
                className={coverSlide ? 'c-slideElement' : 'c-slideElement u-flex u-v-center u-h-around'}
            >
                <BaseElementWrapper isActive={false} isError={hasError} onOptions={onOptions} element={element} lockGeometry={coverSlide}>
                    <ElementTyped element={element} device={DeviceType.MOBILE} />
                </BaseElementWrapper>
            </div>
        </ElementContextMenuTrigger>
    );
}

export default ElementComponentMobile;
